import { useMutation } from 'react-query'
import { get, postAPI } from 'framework/api/http'

interface GetPWBulkConsignmentHistoryInterface {
  take?: number
  skip?: number
  status?: any
  bulkReferance?: any
  filterVariables?: any
  splitReferance?: any
}

export const useGetPWBulkConsignmentHistory = () => {
  const mutate = useMutation(
    ({
      take,
      skip,
      status,
      filterVariables,
      bulkReferance,
      splitReferance,
    }: GetPWBulkConsignmentHistoryInterface) => {
      return postAPI(`/PWBulkConsignmentSummary`, {
        take,
        skip,
        status,
        bulkReferance,
        principle: filterVariables?.principle?.label,
        consNo: filterVariables?.consNo,
        user: filterVariables?.user?.label,
        createdFrom: filterVariables?.createdFrom ?? '',
        createdTo: filterVariables?.createdTo ?? '',
        consignedFrom:
          status != 'Pending' && status != 'InProgress'
            ? filterVariables?.consignedFrom
            : '',
        consignedTo:
          status != 'Pending' && status != 'InProgress'
            ? filterVariables?.consignedTo
            : '',
        splitReferance: splitReferance ?? '',
      })
    },
  )

  return mutate
}

export default useGetPWBulkConsignmentHistory
